import { ProfileMenuOrganizationItem } from './profile-menu-organization-item';
import type { TMember } from '@src/shared/types/member';

export function ProfileMenuOrganizationList({
  memberships,
}: {
  memberships?: TMember[];
}) {
  return (
    <div
      style={{ scrollbarWidth: 'none' }}
      className='max-h-[300px] overflow-y-auto'
    >
      {memberships
        ?.filter((membership) => membership.is_active)
        .map(({ organization }) => (
          <ProfileMenuOrganizationItem
            key={organization.id}
            organization={organization}
          />
        ))}
    </div>
  );
}
